import { Avatar } from 'antd';
import clsx from 'clsx';
import Box from 'components/Box';
import { remove } from 'lodash';
import React from 'react';
import shopSelectors from 'services/shop/selectors';
import { IStaffItemData } from 'services/shop/types/staff';
import styled from 'styled-components';
import selected_box_icon from './select-box.svg';
import Checkbox from './Checkbox';

type Props = {
  value?: string[];
  onChange?: (value?: string[]) => void;
};
const StaffApply = ({ value, onChange }: Props) => {
  const staffs = shopSelectors.data.staffs();
  const handleToggleStaff = (o: IStaffItemData) => () => {
    if (value?.includes(o.id)) {
      const temp = [...value];
      remove(temp, s => s === o.id);
      onChange?.([...temp]);
    } else {
      const temp = [...value || []];
      temp.push(o.id);
      onChange?.(temp);
    }
  };

  const onApplyAll = () => {
    if (value?.length !== staffs.length) {
      onChange?.(staffs.map(o => o.id));
    } else {
      onChange?.([]);
    }
  };

  return (
    <Container>
      <Box display='flex' flexDirection='row'>
        <button className='button-all' type='button' onClick={onApplyAll}>
          <Checkbox value={value?.length === staffs.length} />
          <span className='section-label'>
            Applies to all staff
          </span>
        </button>
      </Box>
      <div className="container-staffs">
        {staffs.map(o => (
          <button onClick={handleToggleStaff(o)} type='button' key={o.id} className={clsx('btn-staff-item', value?.includes(o.id.toString()) && 'active')}>
            <Avatar src={o.urlImage || 'A'} size={80} />
            <span>{o.firstName || 'A'}</span>
            <img src={selected_box_icon} alt="selected_box_icon" className='active-icon' />
          </button>
        ))}
      </div>
    </Container>
  );
};

export default StaffApply;
const Container = styled.div`
display: flex;
flex-direction: column;
padding: 16px;
align-items: flex-start;
align-self: stretch;
border-radius: 4px;
gap: 24px;
background: #F6F7FC;
button.button-all {
  display: flex;
  align-items: center;
  gap: 8px;
}

.container-staffs {
  display: grid;
  align-self: stretch;
  gap: 8px;
  grid-template-columns: repeat(auto-fill,minmax(150px, 1fr));
}
button.btn-staff-item {
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background: #FFF;
  position: relative;

  &:active {
    background: #eee;
  }

  .active-icon {
    position: absolute;
    right: 6px;
    top: 6px; 
    opacity: 0;
  }

  &.active {
    background: #C6E9EF;
    .active-icon {
      opacity: 1;
    }
  }


  span {
    color: #1D2129;
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    text-transform: uppercase;
  }
}
`;
